import { CategoryAttachments } from '@core/domain/models/category.models';

/**
 * Check if category should have noindex
 *
 * @param attachments Category attachments
 *
 * @returns True if category should have noindex
 */
export function isNoindexCategory(attachments: CategoryAttachments[]): boolean {
    return attachments?.some(obj => obj.name === 'NOINDEX');
}
